
import { faShare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { 
    FacebookShareButton,
    FacebookIcon,  
    WhatsappShareButton, 
    WhatsappIcon, 
    InstapaperIcon, 
    InstapaperShareButton,
    T, 
    FacebookMessengerShareButton,
    FacebookMessengerIcon
} from "react-share";


export const SharePannel = ({imgUrl, blog}) => {

    const size = 20,
    style={borderRadius: 10, marginInline: 8}

    const baseUrl = "https://mbecuda-global.com"

    const shareUrl = `${baseUrl}/redirect?post_id=${blog?.id}&&title=${encodeURI(blog?.title)}`

    return (
        <div className={classNames('sh-box','flx-c-r')}>
            <div className={classNames("sh-icon",'flx-c-r')}>
                <div className="hr-2">Share</div>
                <FontAwesomeIcon icon={faShare} />
            </div>
            <FacebookShareButton url={shareUrl}>
                <FacebookIcon size={size} style={style} />
            </FacebookShareButton>
            <WhatsappShareButton url={shareUrl} image={imgUrl}>
                <WhatsappIcon size={size} style={style} />
            </WhatsappShareButton>
            <FacebookMessengerShareButton url={shareUrl}>
                <FacebookMessengerIcon size={size} style={style} />
            </FacebookMessengerShareButton>
        </div>
    )
}